import AddPhoto from "../components/BusinessListing/BusinessListingDetails/AddPhoto";
import BusinessName from "../components/BusinessListing/BusinessListingDetails/BusinessName";
import IndustryForm from "../components/BusinessListing/BusinessListingDetails/IndustryForm";
import Container from "../components/layout/Container";
import FilterHeader from "../components/Shared/FilterHeader/FilterHeader";
import MyAccount from "../components/Shared/MyAccount/MyAccount";

const BusinessListingForm = () => {
  return (
    <Container>
      <div className="flex items-start justify-between gap-x-6">
        <div className="w-[25%]">
          <MyAccount />
        </div>
        <div className="grow w-[75%]">
          <FilterHeader
            title={"CREATE YOUR BUISNESS LISTING"}
            dropdown={false}
            className="mt-[60px]"
          />
          <BusinessName />
          <AddPhoto />
          <IndustryForm/>
        </div>
      </div>
    </Container>
  );
};

export default BusinessListingForm;
